import React, { Component } from 'react';
import { withTranslation } from 'react-i18next'
import Moment from 'react-moment';

import OmsattMatrikkelenhetList from './OmsattMatrikkelenhetList.jsx'
import CollapseIcon from '../../../images/collapse copy 5.png'
import ExpandIcon from '../../../images/expand copy 5.png'

class Omsetning extends Component {
    state = {
        isOpened: false
    }

    UNSAFE_componentWillMount = () => {
        if (this.props.antall == 1) this.setState({isOpened: true})
    }

    toggleOmsetning = () => {
        this.setState({isOpened: !this.state.isOpened})
    }

    render() {
        const { t } = this.props
        var omsetning = this.props.omsetning
        var omsetningstype = omsetning.omsetningstype.substr(4)

        var title = []
        title.push(omsetningstype)
        if (omsetning.omsetningsbeloep > 0) {
            title.push(omsetning.omsetningsbeloep)
        }

        return (
            <li>
                <div className="section-header subsection" onClick={this.toggleOmsetning}>
                    <span className={`icon sublevel ${this.props.isLast ? 'sublevel-end' : ''}`}></span>
                    <span className="title"><Moment local>{omsetning.registreringstidspunkt}</Moment> {title.join(' - ')}</span>
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>
                </div>
                <div className={`section-content${this.state.isOpened ? '' : ' collapsed'}`}>
                <div className="row">
                <div className="row">
                        <div className="column">
                            <div className="label">{t('omsetningstype')}</div>
                            <div className="value">{omsetning.omsetningstype}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('omsetningsbeloep')}</div>
                            <div className="value">{omsetning.omsetningsbeloep}</div>
                        </div>
                    </div>
                        <div className="column">
                            <div className="label">{t('boligtype')}</div>
                            <div className="value">{omsetning.boligtype}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('brukstype')}</div>
                            <div className="value">{omsetning.brukstype}</div>
                        </div>
                    </div>
                    <div className="row">
                    <div className="column">
                            <div className="label">{t('registreringstidspunkt')}</div>
                            <div className="value"><Moment local>{omsetning.registreringstidspunkt}</Moment></div>
                        </div>
                    </div>
                    { omsetning.omsatteMatrikkelenheter.length > 0 &&
                    <ul>
                        <OmsattMatrikkelenhetList omsatte={omsetning.omsatteMatrikkelenheter} token={this.props.token} settings={this.props.settings} />
                    </ul>
                    }
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(Omsetning)